module.exports = __webpack_public_path__ + "img/hill.be5030ca.webp";